<template>
  <div class="pin-control">
    <div class="empty-round"></div>
    <!-- <div
      class="pin-control__round item"
      @click="isRound = !isRound"
      :class="{ 'pin-control__round--active': isRound }"
    >
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5008 13.6L16.4008 7.70005C16.5841 7.51672 16.8174 7.42505 17.1008 7.42505C17.3841 7.42505 17.6174 7.51672 17.8008 7.70005C17.9841 7.88338 18.0758 8.11671 18.0758 8.40005C18.0758 8.68338 17.9841 8.91672 17.8008 9.10005L11.2008 15.7C11.0008 15.9 10.7674 16 10.5008 16C10.2341 16 10.0008 15.9 9.80078 15.7L7.20078 13.1C7.01745 12.9167 6.92578 12.6834 6.92578 12.4C6.92578 12.1167 7.01745 11.8834 7.20078 11.7C7.38411 11.5167 7.61745 11.425 7.90078 11.425C8.18411 11.425 8.41745 11.5167 8.60078 11.7L10.5008 13.6Z"
        />
      </svg>
      <div>왕복으로 배송하시겠어요?</div>
    </div> -->
    <div class="pin-control__rotate item">
      <div class="pin-control__rotate--cover">
        <img src="@/assets/img/order/cached.svg" @click="$emit('swapPin')" />
      </div>
    </div>
    <div class="pin-control__add-pin item">
      <div class="pin-control__add-pin--icon" @click="$emit('addPin')">
        <div class="circle">
          <img src="@/assets/img/order/ic_order_plus.svg" />
        </div>
        경유지 추가
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isRound: false,
    };
  },
};
</script>
<style src="@/assets/css/newGlobal.css" scoped></style>
<style scoped>
.pin-control {
  padding: 12px 0px;
}
.pin-control__round--active svg {
  fill: red;
}
.pin-control__round {
  border: 1px solid var(--gray-300);
  border-radius: 12px;
  background-color: var(--white);
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  color: var(--gray-400);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  fill: var(--gray-400);
  width: max-content;
  box-sizing: border-box;
}

.pin-control__round--active svg {
  fill: var(--secondary-400);
}

.pin-control__round--active {
  border: 1px solid var(--secondary-200);
  color: var(--secondary-400);
}
.circle {
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  border: 1px solid var(--gray-300);
  background-color: var(--white);
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.circle img {
  width: 24px;
  height: 24px;
}

.pin-control__add-pin {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  color: var(--gray-500);
  font-weight: 500;
  line-height: 22px;
}

.pin-control__add-pin--icon {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.pin-control__add-pin--icon:hover {
  transition-duration: 0.3s;
  color: var(--gray-600);
}

.pin-control__rotate--cover {
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  background-color: var(--gray-200);
}

.pin-control__rotate--cover:hover {
  transition-duration: 0.3s;
  background-color: var(--gray-300);
}

.pin-control__rotate img {
  width: 24px;
  height: 24px;
}

@media all and (min-width: 1024px) {
  .pin-control {
    width: 660px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .pin-control__rotate {
    display: flex;
    justify-content: center;
  }
}
@media all and (max-width: 1023px) {
  .empty-round {
    display: none;
  }
  .pin-control {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .item:nth-child(1) {
    grid-row: 1 / 2;
    grid-column: 1 / 3;
  }

  .item:nth-child(2) {
    grid-row: 2 / 3;
    grid-column: 1 / 2;
  }

  .item:nth-child(3) {
    grid-row: 2 / 3;
    grid-column: 2 / 3;
  }
  .pin-control__round {
    width: 100%;
  }
  .pin-control__rotate {
    display: flex;
    justify-content: flex-start;
  }
  .empty {
    display: none;
  }
}
</style>
